// extracted by mini-css-extract-plugin
export default {"icon":"Menu_icon__YNNWA"};